import { createApp } from 'vue'
import App from './App.vue'
import '@/style/main.scss';


createApp(App).mount('#app')
